export type Tone = "neutral" | "progress" | "positive" | "warning" | "negative";

const TONE: Record<string, Tone> = {
  // neutral — no action, no alarm
  draft: "neutral", cancelled: "neutral", closed: "neutral", archived: "neutral",
  not_rated: "neutral", withdrawn: "neutral", unclaimed: "neutral",
  not_verified: "neutral", private: "neutral", merged: "neutral",

  // progress — in flight, awaiting someone
  submitted: "progress", pending: "progress", in_review: "progress",
  published: "progress", issued: "progress", part_received: "progress",
  recorded: "progress", proposed: "progress", information_requested: "progress",
  claim_pending: "progress", suggested: "progress", buyers_only: "progress",

  // positive — done, correct
  approved: "positive", received: "positive", matched: "positive",
  active: "positive", awarded: "positive", paid: "positive",
  reconciled: "positive", accepted: "positive", met: "positive",
  low_risk: "positive", claimed: "positive", verified: "positive",
  confirmed: "positive", public: "positive",

  // warning — needs attention, not yet failed
  exception: "warning", on_hold: "warning", expiring: "warning",
  disputed: "warning", challenged: "warning", watch_risk: "warning", expired: "warning",

  // negative — failed, blocked, or late
  rejected: "negative", breached: "negative", failed: "negative",
  overdue: "negative", blocked: "negative", missed: "negative",
  elevated_risk: "negative", revoked: "negative", suspended: "negative",
};

export function toneForStatus(value: string | null | undefined): Tone {
  return TONE[String(value || "").trim().toLowerCase()] ?? "neutral";
}
